import { z } from 'zod'

/**
 * 問題答覆 - 更新/新增 Response Schema
 */
export const upsertServiceIssueResponseSchema = z.object({
  /** 技術服務問題ID */
  siID: z.number(),
  /** 問題記錄ID */
  slID: z.number()
})

/**
 * 問題答覆 - 更新/新增 Response
 */
export interface UpsertServiceIssueResponse
  extends z.infer<typeof upsertServiceIssueResponseSchema> {}
